import type { FaireProductEntity } from "../../entity_types/product";

export const p_r77rz57nz2: FaireProductEntity = {
  token: "p_r77rz57nz2",
  type: "product",
  name: "Chaga - Fruiting Body - 1:1 Water Extracted - Organic",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/cdec793f92f58591561f34782af60dad5a505255008885f7cc53594156059491.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ce43dc2cab5b421d4b06091e6a8e22d19fbfa38b9a190d37e4e037dd5da0c57.png",
    "https://cdn.faire.com/fastly/25d3414a303a64d53c7a658bc7878f7a6181c83c3bd97a8a52c27d14ef20e71e.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nWe love Chaga for its full body fortification, nourishment, and revitalizing qualities. Work with Chaga to reduce oxidative stress, reduce blood sugar, and protect the liver.* \n\nOur Chaga is organically cultivated in its favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability).\n\nFun Fact: The Khanty people native to Western Siberia used Chaga medicinally, recorded in the 12th century, to protect against the onset of degenerative diseases. They used it to increase vitality and live a long, healthy life\n\n\nBETA GLUCANS | 160mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:48.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
